import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { analytics } from 'firebase'

import { useHistory } from 'react-router-dom'

import classes from './style.module.css'
import UniquePaymentServices from './UniquePaymentServices'
import activateSecondScreenHandler from './activateSeconsScreen'

import { destinationAction, emailAction, destinationTagAction } from '../../../../../redux/stores/firstScreen/action'

import { strings } from '../../../../../i18n'
import { createOrderButtonHandler } from '../../secondScreen/renderSecondScreen'

import config from '../../../../../config/environment'

import Loader from '../../../../../images/icon/loaderWhite.svg'
import store from '../../../../../redux'

const { dispatch } = store

const reCaptchaRef = React.createRef()

const outDestinationInputHandler = (state, event) => dispatch(destinationAction(state, event.target.value))

const emailInputHandler = (state, event) => dispatch(emailAction(state, event.target.value))

const outDestinationTagInputHandler = (state, event) => dispatch(destinationTagAction(state, event.target.value))

const checkCardData = (state) => {
    if (typeof state.equivalentData !== 'undefined' && state.equivalentData) {
        const exchangeWayInfo = state.allExchangeWays.find(way => way.exchangeWayId === state.equivalentData.exchangeWayId);
        if (state.payway === 'CARD' || state.payway.indexOf('VISA_MC') !== -1) {
            if ((!state.cardData || state.cardData.status !== 'SUCCESS') && exchangeWayInfo.inCurrency.type === 'FIAT') { return true }
        }

        if (state.payway === 'QIWI') {
            if ((!state.cardData || !state.cardData.number) && exchangeWayInfo.inCurrency.type === 'FIAT') return true
        }


        return false
    } else { return true }
}

// Payment Services
const PaymentServices = (props) => {

    const { state } = props

    const history = useHistory();

    const pathUrl = (url) => {
        history.push('/' + url);
    }

    return (
        <div className={classes.paymentServices__wrapper}>
            <div className={classes.destination__wrapper}>
                <textarea
                    className={state.destinationValid ? classes.not__destination : classes.destination}
                    readOnly={state.editOutDestination}
                    placeholder={(state.payway === 'MOBILE_PHONE' || state.payway === 'QIWI') && state.exchangeWayType !== 'BUY' ? strings('firstScreen.phoneNumber') : (state.exchangeWayType === 'SELL' ? strings('firstScreen.card') : strings('firstScreen.outDestination'))}
                    onChange={event => outDestinationInputHandler(state, event)}
                    value={state.outDestination || ''}
                    rows={state.outDestination && state.outDestination.length > 25 ? 2 : 1} />
                {state.destinationValid ?
                    <div className={classes.destination__error}>
                        {(state.payway === 'MOBILE_PHONE' || state.payway === 'QIWI') && state.exchangeWayType !== 'BUY' ? strings('firstScreen.phoneNumber') :
                            state.exchangeWayType === 'SELL' ? strings('firstScreen.card') : strings('firstScreen.outDestination')}
                        {' ' + strings('firstScreen.outDestinationError')}
                    </div> :
                    null}
            </div>
            {
                state.outCurrency === 'XRP' || state.outCurrency === 'XLM' || state.outCurrency === 'BNB' ?
                    <div className={classes.destination__wrapper}>
                        <textarea
                            className={classes.destination}
                            placeholder={strings('firstScreen.outDestinationTag')}
                            onChange={event => outDestinationTagInputHandler(state, event)}
                            value={state.outDestinationTag || ''}
                            rows="1" />
                    </div> : null
            }
            <input
                autoComplete="off"
                className={state.emailMessage ? classes.not__email : classes.email}
                type="email" placeholder='Email'
                onChange={event => emailInputHandler(state, event)}
                value={state.email || ' '} required={true}
                readOnly={state.editEmail}
            />
            <UniquePaymentServices state={state} />
            <div className={classes.button} style={{ paddingBottom: 40 }}>
                <button
                    style={{ backgroundColor: checkCardData(state) ? '#999999' : '#864DD9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    onClick={checkCardData(state) ? null : async () => {
                        analytics().logEvent('dataInputScreen_click_' + state.exchangeWayType.toString().toLowerCase())
                        state.externalId ?
                            await createOrderButtonHandler(state, reCaptchaRef, true) :
                            activateSecondScreenHandler(state, pathUrl)
                    }}>
                    {strings('firstScreen.' + state.exchangeWayType.toString().toLowerCase()) || strings('firstScreen.createOrder')}
                    {state.isFetching && state.externalId ?
                        <div className={classes.preloader}>
                            <img src={Loader} alt={'Preloader'} height={40} />
                        </div>
                        : null}
                </button>
            </div>
            <ReCAPTCHA
                ref={reCaptchaRef}
                size="invisible"
                sitekey={config.captchaSiteKey}
                style={{ position: 'absolute', top: '20%' }}
            />
        </div>
    )
}

export default PaymentServices
